import type { RouteRecordRaw } from 'vue-router'

const roleRoutes: RouteRecordRaw[] = [
  {
    path: '',
    component: () => import('@/pages/role/page-list.vue'),
    name: 'role list',
    meta: { title: 'List Hak Akses' },
  },
]

export default roleRoutes
